import { render } from "./FTLOrderId.vue?vue&type=template&id=f8aa3b94&scoped=true&ts=true"
import script from "./FTLOrderId.vue?vue&type=script&lang=ts"
export * from "./FTLOrderId.vue?vue&type=script&lang=ts"

import "./FTLOrderId.vue?vue&type=style&index=0&id=f8aa3b94&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8aa3b94"]])

export default __exports__